module.exports = __webpack_public_path__ + "img/icon_earth_blue.fb3f8a42.png";